<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-19 09:50:04
-->
<template>
<a-spin :spinning='loading'>
  <div class="site-box">
    <div class="search-box">
        <a-select
              showArrow
              v-model="siteIds"
              style="width: 200px; margin-left: 8px;margin-top:14px;margin-bottom:14px"
              @change="changeSite"
            >
              <a-select-option
                :key="index"
                v-for="(item, index) in sitesData"
                :value="item.siteId"
                >{{ item.name }}</a-select-option
              >
    </a-select>
    <div class="img-box">
      <img v-if="disabled"
              class="add-img"
              src="@/assets/images/suo.jpg"
            />
       <img v-if="!disabled"
              class="add-img-two"
              src="@/assets/images/jiesuo.jpg"
            />
      <a @click="jiesuo">编辑栏目权限</a>
    </div>
    </div>
    <div class="column-box">
      <a-tree
      v-model="checkedKeys"
      :checkStrictly="false"
      :disabled="disabled"
      checkable
      :auto-expand-parent="autoExpandParent"
      :tree-data="treeData"
    />
     
     <div class="check-box">
          <a-checkbox :disabled="disabled" v-model="checkZl"  @change="onChange">
            增量栏目
          </a-checkbox>
          <a-popover placement="right" overlay-class-name="pops">
        <template slot="content">
            <div>增量栏目是指对后续增加的栏目进行权限设置</div>
        </template>
         <img 
              class="imgTree"
              src="@/assets/images/wenhao.jpg"
            />
      </a-popover>
           
     </div>
    </div>
    <a-button v-if="this.codeData.indexOf('286') != -1" :disabled="disabled || !siteIds"  @click="submitSite" class="btn-box" type="primary">
      保存
    </a-button>
  </div>
  </a-spin>
</template>

<script>
import {columnTree,selectListBySiteId,siteSaveConfig,selectSiteListByOrgId} from './organizational_structure'
export default {
  data() {
    return {
      treeData: [],
      expandedKeys: [],
      autoExpandParent: true,
      disabled:true,
      checkedKeys: [],
      loading:false,
      siteIds:'',
      sitesData:[],
      siteItem:{},
      checkZl:false,
      codeData: [],
    };
  },
  components: {},
  props:['organizationId'],
  mounted() {
    this.siteList();
     this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
   watch:{
    organizationId(){
        this.siteList();
    }
  },
  methods: {
    onChange(e){
        console.log(e.target.checked,'sss')
    },
    jiesuo(){
        this.disabled = !this.disabled;
    },
    changeSite(value){
        this.siteIds = value;
        this.treeList();
    },
    siteList(){
        this.loading = true;
        if(this.organizationId){
          selectSiteListByOrgId({
            id:this.organizationId,
        }).then((res)=>{
            if(res.code == 0){
                this.sitesData = JSON.parse(JSON.stringify(res.data));
                this.siteIds = res.data.length > 0 &&  res.data[0].siteId || '';
                if(res.data.length > 0){
                    this.treeList();
                }else{
                   this.checkedKeys = [];
                    this.treeData = [];
                }
            }
            this.loading = false;
        })
        }
    },
     treeList(){
        this.loading = true;
        columnTree({
            siteId: this.siteIds
        }).then((res)=>{
                if(res.code == 0){
                        let options = JSON.stringify(res.data)
                        .replace(/columnName/g, "title")
                        .replace(/id/g, "key");
                        this.$nextTick(()=>{
                          this.treeData = JSON.parse(options)
                          this.selectKeys();
                        })
                }
                this.loading = false;
                
        })
     },
     selectKeys(){
            this.loading = true;
            selectListBySiteId({
                orgId:this.organizationId,
                id:this.siteIds,
            }).then((res)=>{
                if(res.code == 0){
                        let array = [];
                        for (let index = 0; index < res.data.configList.length; index++) {
                            const element = res.data.configList[index];
                            array.push(element.columnId)
                        }
                        this.checkZl = res.data.incremental ? true : false;
                        this.$nextTick(()=>{
                            this.checkedKeys = array; 
                            this.disFn(this.treeData)
                        })                 
                }
                 this.loading = false;
            })
     },
     disFn(data){
            for (let index = 0; index < data.length; index++) {
                if(data[index].children){
                    if(this.checkedKeys.indexOf(data[index].key) != -1){
                        this.checkedKeys.splice(this.checkedKeys.indexOf(data[index].key),1)
                    }
                    this.disFn(data[index].children)
                }
            }
            return data;
        },
    submitSite(){
      this.loading = true;
        let incremental = this.checkZl ? 1 : 0;
        siteSaveConfig({
             id:this.siteIds,
             orgId:this.organizationId,
             incremental,
             idList: this.checkedKeys,
        }).then((res)=>{
            if(res.code == 0){
                this.selectKeys();
            }
             this.loading = false;
        })
    },
  },
};
</script>

<style lang="less" scoped>
    .site-box{
        padding-left: 16px;
    }
    .btn-box{
        margin-top: 24px;
    }
    /deep/ .ant-select-selection {
        background: #f7f7f7;
      }
  .search-box{
    display: flex;
    align-items: center;
  }
  .add-img{
    width: 18px;
    height: 18px;
    margin-top:-1px;
  }
  .img-box{
    margin-left: 24px;
  }
  .add-img-two{
     width: 18px;
    height: 18px;
    margin-top:-2px;
  }
  .check-box{
    margin-left: 27px;
    display: flex;
    align-items: center;
  }
  .imgTree{
    width: 20px;
    height: 20px;
    margin-top: 1px;
  }
  .pops{
    .ant-popover-inner-content{
    padding-bottom: 5px !important;
  }
  }
  /deep/ .ant-checkbox + span{
      padding-left:6px;
  }
  .column-box{
     max-height: 410px;
      overflow-y: auto;
  }
</style>